import { ArchiveMinusIcon } from './ArchiveMinusIcon';

/**
 * author: Colton Wiscombe
 * id 0C3AB42B-5B81-46D3-A4BB-DB367FC99B3F
 * name archive-minus
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-minus.svg
 * tags
 */
export const BoxMinusIcon = ArchiveMinusIcon;
export default BoxMinusIcon